import { trendingPosts } from "@/mocks/homeData";

const tagStyle: Record<string, string> = {
  爆: "bg-primary-500 text-background-50",
  热: "bg-primary-100 text-primary-800",
  新: "bg-accent-100 text-accent-900",
};

export default function TrendingRanking() {
  return (
    <section id="trending" className="w-full border-b border-background-200/70 bg-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4 md:mb-10">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.25em] text-primary-600">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-fire-line text-sm" />
              </span>
              Trending
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              今日热帖榜
            </h2>
            <p className="mt-2 text-sm text-foreground-500 md:text-base">
              按围观热度实时滚动，翻两页就有新谈资。
            </p>
          </div>
          <a
            href="#discussion"
            className="whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            完整榜单 →
          </a>
        </div>

        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <ul className="divide-y divide-background-200/80">
            {trendingPosts.map((post) => (
              <li key={post.id}>
                <a
                  href="#discussion"
                  className="group flex items-start gap-4 p-4 transition-colors hover:bg-background-100 md:gap-6 md:p-6"
                >
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold md:h-10 md:w-10 md:text-lg ${
                      post.rank <= 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {post.rank}
                  </span>

                  <span className="min-w-0 flex-1">
                    <span className="flex flex-wrap items-center gap-2">
                      <span className="text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
                        {post.title}
                      </span>
                      <span
                        className={`rounded px-1.5 py-0.5 text-[11px] font-medium ${tagStyle[post.tag]}`}
                      >
                        {post.tag}
                      </span>
                    </span>
                    <span className="mt-1.5 block text-xs leading-relaxed text-foreground-500 md:text-sm">
                      {post.summary}
                    </span>
                  </span>

                  <span className="hidden shrink-0 flex-col items-end gap-1 sm:flex">
                    <span className="flex items-center gap-1 text-xs text-foreground-400">
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-eye-line text-sm" />
                      </span>
                      热度
                    </span>
                    <span className="font-heading text-sm font-semibold text-accent-700 md:text-base">
                      {post.heat}
                    </span>
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}